/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Room_To_Import_PlanningInputs */



/**
* | output |
* | --- |
* | "Select a room to import its planning" |
*
* @param {Select_Room_To_Import_PlanningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const select_room_to_import_planning = /** @type {((inputs?: Select_Room_To_Import_PlanningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Room_To_Import_PlanningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Select a room to import its planning")
	return /** @type {LocalizedString} */ ("Sélectionner une pièce pour importer son planning")
});